module.exports = __webpack_public_path__ + "img/check-grey.10499919.svg";